import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImageLoader from "../../other-components/ImageLoader";
import general from "../../css/General.module.css";
import style from "./style.module.css";

function Modal({ title, description, data, spaceAbove }) {
    // keep track of which images are loaded
    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = (index, loaded) => {
        setLoadedImages((prev) => ({
            ...prev,
            [index]: loaded,
        }));
    };

    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            {title ?
                <div className={style.headerView}>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                : null
            }

            <div className={style.contentsView}>
                {data != null &&
                    data.map((data, index) => (
                        <Link
                            key={"v1_" + index}
                            className={style.item}
                            to={"/p/" + data["item_slug"]}
                        >
                            <div className={style.imageView}>
                                <ImageLoader
                                    className={`${style.image} lazy-loading`}
                                    src={data["item_media"]}
                                    alt={data["item_media"]}
                                    onLoadChange={(loaded) =>
                                        handleImageLoad(index, loaded)
                                    }
                                />

                                {/* Show highlight only after image loads */}
                                {loadedImages[index] &&
                                    data["item_highlight"]?.label && (
                                        <div className={style.highlightView}>
                                            {data["item_highlight"]["label"]}
                                        </div>
                                    )}
                            </div>

                            <h6 className={style.pricing}>
                                ₹{data["item_offered_price"]}
                                {data["item_offer"] !== "0" && (
                                    <s>₹{data["item_price"]}</s>
                                )}
                            </h6>

                            <h6
                                className={[
                                    style.title,
                                    general.wClac90,
                                    general.overflowHiddenEllipsis,
                                ].join(" ")}
                            >
                                {data["item_name"]}
                            </h6>

                            <div className={style.tag}>
                                {data["item_tags"]}
                            </div>
                        </Link>
                    ))}
            </div>
        </div>
    );
}

export default Modal;